import 'babel-polyfill'
import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'

import routes from './router'
import store from './store/'

import '../src/styles/common.css'

Vue.config.productionTip = false
Vue.use(VueRouter)

Vue.prototype.$axios = axios
Vue.prototype.$filters = Vue.options.filters

const router = new VueRouter({
  mode: 'history',
  base: '/xcross/',
  routes
})

new Vue({
  router,
  store
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js